module.exports = __webpack_public_path__ + "img/maintenance.97aa662b.svg";